// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { RadioStyle } from "@insite/mobius/Radio";
import { accountSettingsDefaultBillingShippingStyles } from "@steiner/Overrides/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import Edit from "@steiner/XDL/Icons/Edit";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { createLinkIconStyles } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.headingText = {
    variant: "h2",
    css: css`
        margin: 4px 0;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultShippingRadioGridItem = {
    width: 12,
    css: css`
        padding: 5px 10px;
    `,
};

accountSettingsDefaultBillingShippingStyles.customerSelectorGridContainer = {
    gap: 15,
    css: css`
        margin: 15px;
    `,
};

accountSettingsDefaultBillingShippingStyles.defaultFulfillmentMethodRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        & > ${RadioStyle} {
            margin-right: 20px;
            display: inline-flex;
            input[type="radio"] {
                margin: 0;
            }
        }
        ${RadioStyle} + ${RadioStyle} {
            margin-top: 0;
        }
    `,
};

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    gridContainer: { gap: 5 },
    headingGridItem: { width: 12 },
    headerText: {
        variant: "h3",
        css: css`
            margin: 0;
        `,
    },
    changeLink: {
        ...createLinkIconStyles({
            icon: Edit,
            linkStyles: {
                css: css`
                    margin-left: 30px;
                    margin-top: 6px;
                    white-space: nowrap;
                `,
            },
        }),
    },
    warehouseGridItem: {
        width: 12,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
        },
    },
};

accountSettingsDefaultBillingShippingStyles.warehouseAddressWrapper = {
    width: 12,
};

accountSettingsDefaultBillingShippingStyles.defaultCustomerMessage = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        display: block;
        margin-bottom: 12px;
    `,
};
